<div class="row">
  <div class="requestCOIOuter stock-transfer-outer" (window:resize)="onresize($event)">
    <div class="request-coi-page sot-entry">
      <div class="row">
        <div class="col-md-10">
          <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active">
                  <a href="javascript:void(0)" (click)="navigateToLandingPage()">Stock Transfers</a>
                  <i class="fas fa-angle-right"></i>
                </li>
                <li class="breadcrumb-item breadcrumbColor xs-pr-0 active">
                  <span id="spnBreadcrum">Transfer Request # {{orderNumber}}</span>
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div class="col-md-2 text-right">
          <div class="pt-2">
            <div>
              <ul *ngIf="isHeaderButtonsEnable()">
                <li matTooltip="Pdf" class="pdf-icon margin-r10 cursor" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp" (click)="generatedPdf(sotRequestId)">
                </li>
                <li class="mail-icon margin-r10 cursor" matTooltip="Email" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp" (click)="emailOrderDetail(sotRequestId)">
                </li>
                <li (click)="openRequestHistorySlider()" class="clock-icon cursor d-none d-md-inline-block" matTooltip="Request History" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="returnTop xs-mb-5">
        <div>
          <div class="row">
            <!--From Ship To Select List-->
            <div class="ml-lg-5 ml-md-0 col-12 col-md-6 material-select arrow-remove withBordr">
              <div class="row">
                <div class="w-25 wide-sm-50 position-relative transferAccount padding-l15">
                  Transfer From Account:*
                </div>
              </div>
              <div class="lineHeight">
                <div class="mb-0 mt-1" *ngIf="toAccountName">{{fromShipToAccountItems?.accountName}}</div>
                <div class="mb-0 py-1" *ngIf="toAccountName">{{fromShipToAccountItems?.address1}},  {{fromShipToAccountItems?.city}}, {{fromShipToAccountItems?.state}} - {{fromShipToAccountItems?.zipCode}}</div>
                <div class="py-1 mb-2  font-11" *ngIf="toAccountName">Account #: {{fromShipToAccountItems?.accountNumber}}</div>
              </div>
            </div>

            <div class="col-12 col-md-5">
              <div class="row">
                <div class="w-25 wide-sm-50 position-relative transferAccount padding-l15">
                  Transfer To Account:*
                </div>
              </div>
              <div class="lineHeight">
                <div class="mb-0 mt-1" *ngIf="toAccountName">{{toAccount?.accountName}}</div>
                <div class="mb-0 py-1" *ngIf="toAccountName">{{toAccount?.address1}},  {{toAccount?.city}}, {{toAccount?.state}} - {{toAccount?.zipCode}}</div>
                <div class="py-1 mb-2 font-11" *ngIf="toAccountName">Account #: {{toAccount?.accountNumber}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Delivery Option-->
      <div class="returnTop xs-pb-0">
        <div class="row">
          <div class="col-12 col-md-3 radio-label">
            <label id="example-radio-group-label" class="col-11">
              DELIVERY OPTIONS:
            </label>
            <div (click)="toggleDeliveryMobile()" class="xs-expand-none text-center left-sm-5 d-block d-md-none col-1">
              <i class="fa angle" [ngClass]="isExpandedDeliveryMobile ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </div>
          </div>
          <div class="col-12 col-md-9" [@detailExpandDeliveryMobile]="isExpandedDeliveryMobile ? 'collapsedDeliveryMobile' : 'expandedDeliveryMobile'">
            <mat-radio-group aria-labelledby="example-radio-group-label"
                             class="example-radio-group"
                             [(ngModel)]="deliveryOption">
              <mat-radio-button class="custom-radio" *ngFor="let delivery of deliveryOptionList" [value]="delivery.id"
                                [disabled]="delivery.id!=deliveryOption">
                {{delivery.value}}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <!--Pickup Information Section  [ngClass]="!isAddProductEnable ? 'disabled-icon' : ' '"-->
      <div class="returnTop xs-pb-0">
        <h6 class="form-group-title d-flex justify-content-between xs-mb-0" [ngClass]="!isSubmit ? 'text-fade' : ''">
          Pickup Information: <span class="xs-ml-5 flex-one">(From Account)</span> <span (click)="togglePickup()" class="xs-expand-none xs-mr-20">
            <i class="fa angle" [ngClass]="isExpanded ? 'fa-angle-down' : 'fa-angle-up'"></i>
          </span>
        </h6>
        <div class="row" [@detailExpand]="isExpanded ? 'collapsed' : 'expanded'">
          <div class="col-lg-3 col-md-6">
            <div class="text-center deliveryDatePicker required-input-field">
              <mat-form-field>
                <mat-label>Desired Pickup Date</mat-label>
                <input [readonly]="true"  matInput [(ngModel)]="fromDesiredPickupDate" name="dateName" required>
              </mat-form-field>
            </div>
            <div class="padding-top80">
              <div class="requiredText">*required when Delivery Option "WFU Arranged" is selected</div>
              <div><span class="redAsktrik">*</span><span>always required</span></div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 ">
            <div class="required-input-field blueAstrick">
              <mat-form-field class="wide100">
                <mat-label>Contact Name :</mat-label>
                <input matInput type=text name="ContactName"
                       [(ngModel)]="fromContactName"
                       #name="ngModel"
                       [readonly]="true"
                       required />
              </mat-form-field>
            </div>
            <div class="required-input-field blueAstrick">
              <mat-form-field class="wide100">
                <mat-label>Contact Number :</mat-label>
                <input matInput type=text name="Contact Number"
                       autocomplete="new-username"
                       [(ngModel)]="fromContactNumber"
                       mask="000-000-0000"
                       #phone="ngModel"
                       [readonly]="true"
                       required />
              </mat-form-field>
            </div>
            <div class="required-input-field">
              <mat-form-field class="wide100">
                <mat-label>Customer PO Number :</mat-label>
                <input matInput type=text name="Customer PO Number"
                       autocomplete="new-username"
                       [(ngModel)]="fromCustomerPONumber"
                       maxlength="25"
                       [readonly]="true" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 material-select withBordr not-required-select">
            <ng-select name="ddlFromDeliveryAccount"
                       [items]="deliveryAccountList"
                       class="custom-select-grower  grower-add-drop pb-0"
                       [virtualScroll]="true"
                       [(ngModel)]="fromDeliveryAccount"
                       [disabled]="true"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Pickup Location:"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn">
            </ng-select>
            <div>
              <label for="specialInst" class="checkbox-color mb-0">Shipping Instructions:</label>
              <mat-form-field class="example-full-width specialInst mt-0" floatLabel="never">
                <textarea style="resize:none;height:auto;" matInput rows="6"
                          [(ngModel)]="fromShippingInstructions"
                          appearance="fill"
                          [maxLength]="500"
                          [readonly]="true"></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-lg-3 col-md-6 material-select withBordr">
            <div class="freight-dd">
              <label>Freight Instructions:</label>
              <div class="dd-scroll">
                <mat-selection-list #freightInstructionCtrl [(ngModel)]="selectedFreightInstructionOptions">
                  <mat-list-option *ngFor="let item of freightInstruction" [value]="item" [disabled]="true">
                    {{item.value}}
                  </mat-list-option>
                </mat-selection-list>
              </div>
            </div>
            <div class="row no-gutter">
              <div class="col-3 col-md-6 xs-pl-15 required-input-field redAstrickInput">
                <mat-form-field class="wide100">
                  <mat-label>Non Stock Pallet :</mat-label>
                  <input matInput type="text" name="Non Stock Pallet"
                         autocomplete="new-username"
                         [(ngModel)]="fromNonStockPallet"
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                         #count="ngModel"
                         [readonly]="true"
                         required />
                </mat-form-field>
              </div>
              <div class="col-3 col-md-6 xs-pl-15 required-input-field redAstrickInput">
                <mat-form-field class="wide100">
                  <mat-label>Stock Pallet :</mat-label>
                  <input matInput type="text" name="Stock Pallet"
                         autocomplete="new-username"
                         [(ngModel)]="fromStockPallet"
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                         #count1="ngModel"
                         [readonly]="true"
                         required />
                </mat-form-field>
              </div>
              <div class="col-3 col-md-6 xs-pl-15 required-input-field redAstrickInput">
                <mat-form-field class="wide100">
                  <mat-label>Empty CBox :</mat-label>
                  <input matInput type="text" name="CBox"
                         autocomplete="new-username"
                         [(ngModel)]="fromCBox"
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                         #count2="ngModel"
                         [readonly]="true"
                         required />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Delivery Information-->
      <div class="returnTop xs-pb-0">
        <h6 class="form-group-title d-flex justify-content-between xs-mb-0" [ngClass]="isSubmit ? 'text-fade' : ''">
          Delivery Information: <span class="xs-ml-5 flex-one">(To Account)</span> <span (click)="togglePickupDelivery()" class="xs-expand-none xs-mr-20">
            <i class="fa angle" [ngClass]="isExpandedDelivery ? 'fa-angle-down' : 'fa-angle-up'"></i>
          </span>
        </h6>
        <div class="row" [@detailExpand]="isExpandedDelivery ? 'collapsed' : 'expanded'">
          <div class="col-lg-3 col-md-6">
            <div class="text-center deliveryDatePicker required-input-field" *ngIf="requestStatus=='SUBMITTED'">
              <mat-form-field>
                <input matInput [matDatepicker]="picker" placeholder="Desired Delivery Date" (focus)="picker.open();" [matDatepickerFilter]="dateFilter" [(ngModel)]="toDesiredPickupDate" [min]="minDate" #dateName="ngModel"
                       name="dateName" oninput="this.value=this.value.replace(/[^0-9/]/g,'');"
                       (change)="desiredPickupDateValid(dateName)" (dateChange)="validateSelectedDesiredPickupDate($event)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker>
                  <div #datepickerFooter>
                    <div class="row border-top m-0">
                      <div class="col-sm-5 col-5 pr-0">
                        <div class="p-1 ">
                          <span class="white-date-box d-inline-block align-middle"></span>
                          <span class="calender-legend">
                            Today's Date
                          </span>
                        </div>
                        <div class="p-1">
                          <span class="green-date-box d-inline-block align-middle"></span>
                          <span class="calender-legend">
                            Requested Delivery
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-datepicker>
              </mat-form-field>
            </div>
            <div class="text-center deliveryDatePicker required-input-field" *ngIf="requestStatus!='SUBMITTED'">
              <mat-form-field>
                <input [readonly]="true" matInput [matDatepicker]="picker" placeholder="Desired Delivery Date" [matDatepickerFilter]="dateFilter" [(ngModel)]="toDesiredPickupDate" [min]="minDate" #dateName="ngModel"
                       name="dateName">
                <!--<input [readonly]="true" placeholder="Desired Pickup Date :" matInput [(ngModel)]="toDesiredPickupDate" name="dateName" required>-->
              </mat-form-field>
            </div>
            <div class="padding-top80">
              <!--<div>*required when Delivery Option "WFU Arranged" is selected</div>-->
              <div class="requiredText">*required when Delivery Option "WFU Arranged" is selected</div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 ">
            <div class="required-input-field blueAstrick">
              <mat-form-field class="wide100">
                <input matInput type=text name="ContactName"
                       placeholder="Contact Name :"
                       autocomplete="new-username"
                       [(ngModel)]="toContactName"
                       maxlength="15"
                       required
                       #name="ngModel"
                       (change)="nameShouldBeValid(name)"
                       [readonly]="requestStatus!='SUBMITTED'" />
              </mat-form-field>
            </div>
            <div class="required-input-field blueAstrick">
              <mat-form-field class="wide100">
                <input matInput type=text name="Contact Number"
                       placeholder="Contact Number :"
                       autocomplete="new-username"
                       [(ngModel)]="toContactNumber"
                       mask="000-000-0000"
                       #phone="ngModel"
                       required
                       [readonly]="requestStatus!='SUBMITTED'"
                       (change)="phoneShouldBeValid(phone)" />
                <mat-error *ngIf="phone.invalid && (phone.dirty || phone.touched)">Please enter a 10 digit phone number</mat-error>
              </mat-form-field>
            </div>
            <div class="required-input-field">
              <mat-form-field class="wide100">
                <input matInput type=text name="Customer PO Number"
                       placeholder="Customer PO Number :"
                       autocomplete="new-username"
                       [(ngModel)]="toCustomerPONumber"
                       [readonly]="requestStatus!='SUBMITTED'"
                       maxlength="25" />
              </mat-form-field>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 material-select withBordr not-required-select">
            <ng-select name="ddltoDeliveryAccount"
                       [items]="deliveryAccountList"
                       class="custom-select-grower  grower-add-drop pb-0"
                       [virtualScroll]="true"
                       [(ngModel)]="toDeliveryAccount"
                       [disabled]="!deliverToAnotherLocation || requestStatus!='SUBMITTED'"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       placeholder="Delivered To Location:"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}}, {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div *ngIf="requestStatus=='SUBMITTED'">
              <mat-checkbox class="custom-checkbox pr-2"
                            [style.display]=""
                            [checked]=""
                            [indeterminate]=""
                            (change)="updateDeliverToSelection($event.checked)"
                            [(ngModel)]="deliverToAnotherLocation"></mat-checkbox>
              <label class="checkbox-color">If Pickup Location is different than To Account.</label>
            </div>
            <div>
              <label for="specialInst" class="checkbox-color mb-0">Shipping Instructions:</label>
              <mat-form-field class="example-full-width specialInst mt-0" floatLabel="never">
                <textarea style="resize:none;height:auto;" matInput rows="6"
                          [(ngModel)]="toShippingInstructions"
                          appearance="fill"
                          [maxLength]="500"
                          [readonly]="requestStatus!='SUBMITTED'"
                          placeholder="up to 500 characters"></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class=" col-lg-3 col-md-6 material-select withBordr">
            <div class="freight-dd">
              <label>Freight Instructions:</label>
              <div class="dd-scroll">
                <mat-selection-list #freightInstructionCtrl [(ngModel)]="selectedToFreightInstructionOptions">
                  <mat-list-option *ngFor="let item of freightInstruction" [value]="item" [disabled]="requestStatus!='SUBMITTED'">
                    {{item.value}}
                  </mat-list-option>
                </mat-selection-list>
              </div>
            </div>
            <div class="row no-gutter">
              <div class="col-md-6 xs-pl-15 required-input-field redAstrickInput">
                <mat-form-field class="wide100">
                  <input matInput type="text" name="Non Stock Pallet"
                         placeholder="Non Stock Pallet :"
                         autocomplete="new-username"
                         [(ngModel)]="toNonStockPallet"
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                         #count="ngModel"
                         (change)="countShouldBeValid(count)"
                         [readonly]="true" />
                  <mat-error *ngIf="count.invalid && (count.dirty || count.touched)">Please enter the number of Non Stock Pallet being returned</mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-6 xs-pl-15 required-input-field redAstrickInput">
                <mat-form-field class="wide100">
                  <input matInput type="text" name="Stock Pallet"
                         placeholder="Stock Pallet :"
                         autocomplete="new-username"
                         [(ngModel)]="toStockPallet"
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                         #count1="ngModel"
                         (change)="countShouldBeValid(count1)"
                         [readonly]="true" />
                  <mat-error *ngIf="count1.invalid && (count1.dirty || count1.touched)">Please enter the number of Stock Pallet being returned</mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-6 xs-pl-15">
                <mat-form-field class="wide100">
                  <input matInput type="text" name="CBox"
                         placeholder="CBox :"
                         [(ngModel)]="toCBox"
                         maxlength="4" oninput="this.value=this.value.replace(/[^0-9]/g,'');"
                         #count2="ngModel"
                         (change)="countShouldBeValid(count2)"
                         [readonly]="true" />
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="returnTop rejectBorder" *ngIf="!isSubmit && requestStatus=='REJECTED'">
        <label style="color:red; margin-bottom: 0;">This request has been rejected for the following reason:</label>

        <textarea style="resize: none; height: auto; border: none; padding: 0 15px;width: 75%;" matInput
                  [(ngModel)]="rejectionReason"
                  appearance="fill"
                  [maxLength]="3000"
                  [readonly]="true"></textarea>
      </div>
      <div class="returnDetail">
        <!--Product Detail section-->
        <div class="addProdContent">

          <div class="OrderReleaseTop">
            <div class="row">
              <div class="col-md-12">
                <div class="tableContainer prodTableContainer sotEntryTable">
                  <table mat-table #requestTable [dataSource]="productItemsDataSource" multiTemplateDataRows class="matTables seedCropLossTable">

                    <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                      <div *ngIf="column=='checkbox'">
                      <th mat-header-cell *matHeaderCellDef class="colCheckBox"></th>
                </div>

                <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th></div>
                <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="dumpedLines text-center">Pack Size</th></div>
                <div *ngIf="column=='lotNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Lot Number</th></div>
                <div *ngIf="column=='treatment'"><th mat-header-cell *matHeaderCellDef class="units text-center">Treatment</th></div>
                <div *ngIf="column=='productLine'"><th mat-header-cell *matHeaderCellDef class="units text-center">Product Line</th></div>
                <div *ngIf="column=='availability'"><th mat-header-cell *matHeaderCellDef class="availability text-center">Availability</th></div>
                <div *ngIf="column=='requestedQty'"><th mat-header-cell *matHeaderCellDef class="dumpedLines text-center">Requested QTY</th></div>

                <!--<div *ngIf="column=='problemDescription'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Customer Notes</th></div>-->
                <!--id="replantProductTbl_error_{{element.lineErrors.itemId}}_{{element.lineErrors.lotNumber}}"-->
                ma
                <td mat-cell *matCellDef="let element" class="position-relative">
                  <div *ngIf="column=='checkbox'">
                    <div class="lineitem-symbols"></div>
                  </div>

                  <div *ngIf="column=='product'" class="order-info-outer">
                    <div class="order-info ml-0  text-left">
                      <div class="d-block d-md-none">Product Name</div>
                      <p class="prod-id">{{element.itemVendorName}}</p>
                      <p class="prod-name" [matTooltipPosition]="'above'">{{element.itemDescription}}</p>
                      <p class="prod-num">{{element.itemNumber}}</p>
                    </div>
                  </div>

                  <div *ngIf="column=='packageSize'" class="measureUnit text-center  font-14">
                    <p class="mb-0"> {{element.packageSize}} </p>
                  </div>

                  <div *ngIf="column=='lotNumber'" class="measureUnit text-center  font-14">
                    <div class="d-block d-md-none">Lot Number</div>
                    <p class="mb-0"> {{element.lotNumber}} </p>
                  </div>

                  <div *ngIf="column=='treatment'" class="measureUnit text-center  font-14">
                    <p class="mb-0"> {{element.treatment}} </p>
                  </div>

                  <div *ngIf="column=='productLine'" class="measureUnit text-center  font-14">
                    <p class="mb-0"> {{element.productLine}} </p>
                  </div>

                  <div *ngIf="column=='availability' && isSubmit" class="measureUnit text-left text-md-center  font-14">
                    <div class="d-block d-md-none">Availability</div>
                    <p class="mb-0"> {{element.availableQuantity}} </p>
                  </div>

                  <div *ngIf="column=='requestedQty'" class="measureUnit text-center  font-14">
                    <div class="d-block d-md-none">Requested QTY</div>
                    <p class="mb-0"> {{element.requestedQty}} </p>
                  </div>
                </td>
                </ng-container>
                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell class="product-details p-0" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div class="inline-error m-0" *ngIf="element.lineErrors && element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.itemId}}">
                      <div class="row">
                        <div class="col-md-9">
                          <!--<ol class="error-list">-->
                          <ol>
                            <li *ngFor="let err of element.lineErrors.errors">
                              {{err.error}}
                          </ol>
                        </div>
                        <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                          <span>
                            Revert to Previous.
                            <i class="icon-ico-Reply"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;" class="d-none d-md-table-row"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                    class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element"
                    (click)="expandedElement = expandedElement === element ? null : element"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row d-none d-md-table-row"></tr>
                </table>
                <div *ngIf="productItemsDataSource == undefined || productItemsDataSource?.data?.length == 0" class="noDataMsg">
                  <p>No Record Found.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="SeedFulfillBtnSec">
        <div class="row padding-l20 padding-sm-l0">
          <div class="col-12 col-md-8">
            <div class="row">
              <div class="col-12 col-md-3 padding-sm-5" *ngIf="isSubmit">
                <button mat-raised-button class="btns wide100" (click)="createNewOrder()" [style.display]="'inline-block' "> Create New Request</button>
              </div>
              <div class="col-6 col-md-3 padding-sm-5" *ngIf="isSubmit">
                <button mat-raised-button class="btns wide100" (click)="saveRequest('EDITING')" [style.display]="'inline-block'" id="btnEditRequest">Edit Request</button>
              </div>
              <div class="col-6 col-md-3 padding-sm-5" *ngIf="!isSubmit && requestStatus=='SUBMITTED'">
                <button mat-raised-button class="btns wide100" (click)="saveRequest('APPROVED')" [style.display]="'inline-block'" id="btnApprove"> Approve</button>
              </div>
              <div class="col-6 col-md-3 padding-sm-5" *ngIf="!isSubmit && requestStatus=='SUBMITTED'">
                <button mat-raised-button class="btns wide100" (click)="openRejectDialog()" [style.display]="'inline-block'">Reject</button>
              </div>
              <div class="col-md-2 padding-sm-5" [ngClass]="(!isSubmit && requestStatus !='SUBMITTED') || (!isSubmit && requestStatus=='SUBMITTED')  ? 'col-12':'col-6'">
                <button mat-raised-button class="btns wide100" (click)="navigateToLandingPage()" color="primary" [style.display]="'inline-block'" id="btnClose">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
